export const VISITED = 'VISITED'